import React from 'react';
import { ExternalLink } from 'lucide-react';

// A ticket key that opens the ticket in Jira.
export default function JiraKeyChip({ issueKey, url }: { issueKey: string; url: string }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="hit-area-sm inline-flex items-center gap-1 rounded-md bg-blue-50 px-1.5 py-0.5 text-[0.6875rem] font-semibold text-blue-700 ring-1 ring-inset ring-blue-200/60 transition-colors hover:bg-blue-100 motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
    >
      {issueKey}
      <ExternalLink className="h-3 w-3 opacity-60" aria-hidden />
    </a>
  );
}
